import React, {useEffect, useState} from "react";
import "./style.scss";

export default ({color}) => {
    const [lastColor, setLastColor] = useState(color);
    const [faded, setFaded] = useState(false);
    const transitionTime = 500;

    useEffect(() => {
        if (lastColor !== color) {
            setFaded(true);
            const timer = setTimeout(() => {
                setLastColor(color);
                setFaded(false);
            }, lastColor ? transitionTime : 0);

            return () => clearTimeout(timer);
        }
    }, [color]);

    const style = {
        opacity: faded ? 0 : 1,
        transitionDuration: transitionTime + 'ms',
        backgroundImage: `radial-gradient(66.6% 66.6% at 50% 0%, ${lastColor || 'transparent'} 0%, transparent 100%)`,
    };

    return (
        <div className="page-background-glow" style={style} />
    );
}
